export function servicesSlider() {
    const $window = $(window);
    const $slider = $(".services-slider");
    let sliderNav = "";
    let $current = "";
    let $total = "";


    $slider.each(function () {
        let $this = $(this);
        sliderNav = $this.next(".services-slider-nav");
        $current = sliderNav.find('.current');
        $total = sliderNav.find('.total');
        $this.slick({
            dots: !!$slider.parent().hasClass("slider-progress"),
            arrows: true,
            appendArrows: sliderNav,
            appendDots: sliderNav,
            infinite: false,
            speed: 700,
            cssEase: 'ease',
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
            ]
        }).on('init reInit afterChange', function (event, slick, currentSlide) {
            let i = (currentSlide ? currentSlide : 0) + 1;
            $current.text(i);
            $total.text($this.find(".slick-slide:not(.slick-active)").length + 1);
        });
        $total.text($this.find(".slick-slide:not(.slick-active)").length + 1);
        $current.text("1");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/servicesSlider.js